import styled from 'styled-components';
import ds, { media } from 'designsystem';

const MobileImagesWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  min-height: 360px;
  padding: ${ds.get('metrics.s')};
  
   ${media.mobile`
    min-height: 450px;
  `}
  
  ${media.tablet`
    min-height: 600px;
  `}
`;

export default MobileImagesWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/LinkBanner/MobileImagesWrapper.jsx